import { gql } from "@apollo/client";

export const REPLY_TO_CONVERSATION = gql`
  mutation ReplyToConversation($psid: String!, $pageId: String!, $message: String!) {
    replyToConversation(psid: $psid, pageId: $pageId, message: $message) {
      id
      psid
      pageId
      direction
      message
      status
      createdAt
    }
  }
`;

export const MARK_CONVERSATION_READ = gql`
  mutation MarkConversationRead($psid: String!, $pageId: String!) {
    markConversationRead(psid: $psid, pageId: $pageId)
  }
`;
